export default class VariationLoader {
  static loaderClass = "lds-spinner";
  ID;
  element;
  disableClass = false;
  active = false;

  static setID = () => {
    this.ID = document.querySelectorAll(`.${this.loaderClass}`).length + 1;
  };

  static loaderMarkup = (styling = "") => {
    return `<div class="${this.loaderClass} ${styling}" data-loader-id="${this.ID}"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`;
  };

  static remove = () => {
    document.querySelector(`[data-loader-id="${this.ID}"]`).remove();
    if (this.disableClass) {
      this.element.classList.remove("hidden");
    }
    this.active = false;
  };

  static get = (element, position = "beforebegin", styling) => {
    if (this.active) return;

    this.active = true;
    this.setID();
    this.element = element;

    if (position == "beforebegin" || position == "afterend") {
      if (!this.element.classList.contains("hidden")) {
        this.disableClass = true;
        this.element.classList.add("hidden");
      }
    }

    element.insertAdjacentHTML(position, this.loaderMarkup(styling));

    return this;
  };
}
